import React from 'react';
import { Box, ToggleButtonGroup, ToggleButton } from '@mui/material';

type TimeRangeSelectorProps = {
  value: number;
  onChange: (event: React.MouseEvent<HTMLElement>, newValue: number | null) => void;
};

// Use the app's themed CSS variables so the buttons stay legible in dark mode
// (MUI's default text color is dark and unreadable on the dark background).
const toggleButtonSx = {
  color: 'var(--textColor)',
  borderColor: 'var(--borderColor)',
  '&.Mui-selected': {
    color: 'var(--textColor)',
    backgroundColor: 'var(--selectedMorphologyRowBackgroundColor)',
    '&:hover': {
      backgroundColor: 'var(--selectedMorphologyRowBackgroundColor)',
    },
  },
};

export const TimeRangeSelector = ({ value, onChange }: TimeRangeSelectorProps) => {
  return (
    <Box mb={3}>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={onChange}
        aria-label="time range"
      >
        <ToggleButton value={7} aria-label="7 days" sx={toggleButtonSx}>
          7 Days
        </ToggleButton>
        <ToggleButton value={30} aria-label="30 days" sx={toggleButtonSx}>
          30 Days
        </ToggleButton>
        <ToggleButton value={90} aria-label="90 days" sx={toggleButtonSx}>
          90 Days
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
